export default __webpack_public_path__ + "6079a993f6a945acfff90c065f7f5a08.svg";